import React, {useEffect, useState} from 'react'
import {Pagination, Space, Divider} from 'antd'
import './resource.less'
import ResourceCard from './resourceCard'
import API from '../../api'
import {Resource} from '../../api/resource'
import SearchBar from 'components/SearchBar'

const ResourceCom = () => {
  const [current, setCurrent] = useState(1)
  const handlePageChange = page => {
    setCurrent(page)
  }

  // const onSearch = value => {
  //   upadteResourceList()
  // }
  const [fileType, setFileType] = useState('all')
  const [searchText, setSearchText] = useState('')
  // const [searchLoading, setSearchLoading] = useState(false)

  const [resourceList, setResourceList] = useState<Resource[]>([])
  const [total, setTotal] = useState(0)
  // const [currentResourceTagsIndex, setCurrentResourceTagsIndex] = useState(0)
  // const [currentOrderTypesIndex, setCurrentOrderTypesIndex] = useState(0)

  const handleTypeClick = t => {
    if (t.type === fileType) {
      return
    }

    setFileType(t.type)
  }

  // const handleSearchTextChange = e => {
  //   setSearchText(e.target.value)
  // }

  const upadteResourceList = () => {
    // setSearchLoading(true)

    API.listResource({
      offset: (current - 1) * 16,
      limit: 16,
      search: searchText,
      type: fileType,
    })
      .then(res => {
        let rs = res.data.resources
        if (rs !== null) {
          setResourceList(rs)
        } else {
          setResourceList([])
        }
        setTotal(res.data.total)
      })
      .catch(() => {})
      .finally(() => {
        // setSearchLoading(false)
      })
  }

  useEffect(() => {
    //  重新获取数据并渲染
    upadteResourceList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current, fileType])

  // const resourceTagsTabClick = key => {
  //   if (key === currentResourceTagsIndex) return
  //   setCurrentResourceTagsIndex(key)
  // }
  // const orderTypesTabClick = key => {
  //   if (key === currentOrderTypesIndex) return
  //   setCurrentOrderTypesIndex(key)
  // }
  const reset = () => {
    setFileType('all')
    setSearchText('')
  }
  const fileTypes = [
    {
      text: '全部',
      type: 'all',
    },
    {
      text: '图片',
      type: 'image',
    },
    {
      text: '视频',
      type: 'video',
    },
    {
      text: '文档',
      type: 'doc',
    },
    {
      text: '其他',
      type: 'other',
    },
  ]

  // const resourceTags = ['全部', '机器学习', '自然语言处理']
  // const orderTypes = [
  //   {
  //     text: '最新发布',
  //     type: 'update_at DESC',
  //   },
  //   {
  //     text: '最多下载',
  //     type: 'download DESC',
  //   },
  //   {
  //     text: '最多点击',
  //     type: 'click DESC',
  //   },
  // ]

  return (
    <>
      <div style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/resource-banner.png)`}}>
        <SearchBar module="Resource Center" />
      </div>
      <div className="layout-content-mask">
        <div className="layout-content-bg-LB"></div>
        <div className="layout-content-bg-RT"></div>
        <div className="resource-container">
          {/* <div className="search-input">
            <Input.Search
              placeholder="人工智能"
              onSearch={onSearch}
              enterButton
              size="large"
              value={searchText}
              onChange={handleSearchTextChange}
              loading={searchLoading}
            />
          </div> */}
          <div className="resource-type-container">
            <div>
              {fileTypes.map((t, index) => (
                <div className="resource-text" key={index}>
                  <span
                    className={`resource-text-titile-common ${
                      fileType === t.type ? 'resource-text-title' : null
                    }`}
                    onClick={() => handleTypeClick(t)}
                  >
                    {t.text}
                  </span>
                </div>
              ))}
            </div>

            {/* tags 选择 */}
            {/* <div className="resource-tags-line">
              {resourceTags.map((tag, index) => (
                <div className="resource-text" key={index}>
                  <span
                    className={`resource-text-titile-common ${
                      currentResourceTagsIndex === index ? 'resource-text-title' : null
                    }`}
                    onClick={() => resourceTagsTabClick(index)}
                  >
                    {tag}
                  </span>
                </div>
              ))}
            </div> */}
            {/* 排序选择 */}
            {/* <div className="resource-order-line">
              <div className="resource-order-line-group">
                {orderTypes.map((order, index) => (
                  <div className="resource-text" key={index}>
                    <span
                      className={`resource-text-titile-common ${
                        currentOrderTypesIndex === index ? 'resource-text-title' : null
                      }`}
                      onClick={() => orderTypesTabClick(index)}
                    >
                      {order.text}
                    </span>
                  </div>
                ))}
              </div>
            </div> */}
            <div className="reset-btn">
              <span onClick={() => reset()}>重置</span>
            </div>
          </div>
          <Divider className="resource-divider" />
          <div className="resource-card-container">
            <Space size={[40, 40]} wrap style={{marginBottom: 0}}>
              {resourceList.map((r, index) => (
                <ResourceCard resource={r} key={r.resource_id} />
              ))}
            </Space>
          </div>
          <div className="resource-footer">
            <div>
              <span>共 {total} 条内容</span>
            </div>
            <div style={{marginLeft: 24}}>
              <Pagination
                current={current}
                total={total}
                pageSize={16}
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ResourceCom
